import React, { Suspense, lazy, memo } from 'react';
import { canUseDOM } from '../../utils';
const CampaignScriptGeneratorLazyLoadedContent = /*#__PURE__*/lazy(() => import("./CampaignScriptGeneratorLazyLoadedContent"));
const SuspenseWrapper = props => {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(CampaignScriptGeneratorLazyLoadedContent, props));
};
const CampaignScriptGenerator = props => {
  return canUseDOM ? /*#__PURE__*/React.createElement(SuspenseWrapper, props) : null;
};
export default /*#__PURE__*/memo(CampaignScriptGenerator);